import type { RouteObject } from 'react-router-dom';

import type { ArchitectureStatus } from '../../application/dto/ArchitectureStatus';
import type { BuildInfo } from '../../application/dto/BuildInfo';
import type { DailyMissionsClient } from '../../application/services/DailyMissionsService';
import { ArchitecturePage } from '../../presentation/pages/ArchitecturePage';
import { HistoryDetailPage } from '../../presentation/pages/HistoryDetailPage';
import { HistoryPage } from '../../presentation/pages/HistoryPage';
import { SettingsPage } from '../../presentation/pages/SettingsPage';
import { TodayPage } from '../../presentation/pages/TodayPage';
import { AppShell } from '../../presentation/components/AppShell';

export function createRoutes(
  loadStatuses: () => Promise<readonly ArchitectureStatus[]>,
  dailyMissions: DailyMissionsClient,
  buildInfo: BuildInfo,
): RouteObject[] {
  return [
    {
      element: <AppShell />,
      children: [
        { path: '/', element: <TodayPage client={dailyMissions} /> },
        { path: '/today', element: <TodayPage client={dailyMissions} /> },
        { path: '/history', element: <HistoryPage client={dailyMissions} /> },
        { path: '/history/:logicalDate', element: <HistoryDetailPage client={dailyMissions} /> },
        {
          path: '/settings',
          element: <SettingsPage client={dailyMissions} buildInfo={buildInfo} />,
        },
        {
          path: '/architecture',
          element: <ArchitecturePage loadStatuses={loadStatuses} buildInfo={buildInfo} />,
        },
      ],
    },
  ];
}
